import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';

export const testimonialData = [
  {
    quote: "Et aliquet netus at sapien pellentesque mollis nec dignissim maecenas. Amet erat volutpat quisque odio purus feugiat. In gravida neque.",
    name: "Emanuel Boyle",
    title: "Kuppel LLC",
    avatar: "assets/Reviewers/testi-1.jpg"
  },
  {
    quote: "Purus consectetur varius quis urna phasellus enim mattis. Sem tincidunt tortor nunc egestas amet adipiscing ligula.",
    name: "River Graves",
    title: "Glover - Grm",
    avatar: "assets/Reviewers/testi-2.jpg"
  },
  {
    quote: "Quam neque odio urna euismod felis. Sit egestas magna in quisque fame dapibus quis sapien magna. Nisl non eget sit pellentesque tristique et.",
    name: "Ryder Malone",
    title: "Haag LLC",
    avatar: "assets/Reviewers/testi-3.jpg"
  },
  {
    quote: "Velit proin mollis sed quam id nisl semper. Purus non eu cursus porttitor tristique et gravida. Aliquam adipiscing velit semper morbi.",
    name: "Sophia Johnson",
    title: "Travel Enthusiast",
    avatar: "assets/Reviewers/testi-4.jpg"
  }
];

const TestimonialCard = ({ quote, name, title, avatar }) => (
  <div className="flex flex-col shadow-lg rounded-lg overflow-hidden">
    <div className="bg-slate-800 p-8 text-center relative flex-grow">
      <FaQuoteLeft className="text-amber-400 text-4xl mb-4 mx-auto" />
      <p className="text-slate-400 italic text-sm">"{quote}"</p>
    </div>
    
    <div className="bg-slate-900 pt-16 pb-6 px-6 text-center relative">
      <div className="absolute left-1/2 -translate-x-1/2 -top-10">
        <div className="w-20 h-20 rounded-full bg-slate-700 border-4 border-slate-950 shadow-md overflow-hidden flex items-center justify-center text-slate-400">
           IMG
        </div>
      </div>
      <p className="font-bold text-white text-lg">{name}</p>
      <p className="text-sm text-slate-400">{title}</p>
    </div>
  </div>
);

const Testimonials = () => {
  return (
    <section className="bg-slate-950 py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center text-white mb-16">
          Reviews from our customers
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {testimonialData.map((item, index) => (
            <TestimonialCard 
              key={index}
              quote={item.quote}
              name={item.name}
              title={item.title}
              avatar={item.avatar}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;